import FJAppConstant from '../../constants/FJAppConstant';
import { LOCAL, TEST } from '../../constants/FJEvnConstant';

const environment = import.meta.env.MODE;

export default {
    resultImageKey: 'ai/export/avatar/',
    originalImageKey: 'ai/input/avatar/',
    historyListType: 37,
    appType: FJAppConstant.HEADSHOT_GENERATOR,
    presetListJsonPath:
        environment === LOCAL
            ? '/app/ai-tools/resource/headshot-generator/prompts/'
            : environment === TEST
              ? '/app/ai-tools/resource/headshot-generator/prompts/'
              : 'https://resource.flexclip.com/app/ai-tools/resource/headshot-generator/prompts/',
    headshotImagePath:
        environment === LOCAL
            ? 'https://smartvideomaker.com/app/ai-tools/resource/headshot-generator/'
            : environment === TEST
              ? '/app/ai-tools/resource/headshot-generator/'
              : 'https://resource.flexclip.com/app/ai-tools/resource/headshot-generator/',
    // 使用换发的发色资源
    hairColorImagePath:
        environment === LOCAL
            ? 'https://smartvideomaker.com/app/ai-tools/resource/hairstyle-changer/hair-color/'
            : environment === TEST
              ? '/app/ai-tools/resource/hairstyle-changer/hair-color/'
              : 'https://resource.flexclip.com/app/ai-tools/resource/hairstyle-changer/hair-color/',
    currentMenuName: 'ai-headshot-generator',
    freeLimitType: 'headshot-generator',
    generatingPlaceholderVideoUrl:
        environment === LOCAL
            ? 'https://smartvideomaker.com/app/ai-tools/resource/headshot-generator/'
            : environment === TEST
              ? '/app/ai-tools/resource/headshot-generator/'
              : 'https://resource.flexclip.com/app/ai-tools/resource/headshot-generator/',
};
